<div class="modal-header main-modal-header">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">×</button>
    <h4 class="modal-title wrap-text-in" *ngIf="context === 'clientOrBu'">
        Requisitions Containing '{{stepName}}' Step</h4>
    <h4 class="modal-title wrap-text-in" *ngIf="context === 'corporation'">
        BUs Having Requisitions With '{{stepName}}' Step</h4>
    <h4 class="modal-title wrap-text-in" *ngIf="context === 'staffingCompany'">
        Clients Having Requisitions With '{{stepName}}' Step
    </h4>
</div>

<div class="modal-body">
    <div class="row" *ngIf="isDetailsFetched">
        <div class="col-xs-12">
            <p [innerHTML]="message" class="d-inline">
            </p>.
            <a (click)="showDetails()" class="cursor-pointer">Show Details</a>
        </div>
        <div class="col-xs-12 mt-2" *ngIf="showDetailsFlag && isDetailsFetched"
            style="height: 300px;overflow-y: auto;">
            <div *ngIf="context === 'clientOrBu'" style="margin-top:10px;padding:0 10px">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Requisition Number</th>
                            <th>Role Name</th>
                            <th>Candidates in {{stepName}}</th>
                        </tr>
                    </thead>
                    <tbody> 
                        <tr *ngFor="let requisition of requisitions">
                            <td>{{requisition.requisitionActualNumber}}</td>
                            <td>{{requisition.name}} </td>
                            <td>{{requisition.numberOfCandidates}} </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div *ngIf="context !== 'clientOrBu'">
                <p *ngIf="context === 'corporation'">BUs</p>
                <p *ngIf="context === 'staffingCompany'">Clients</p>
                <ol>
                    <li *ngFor="let clientOrBu of clientOrBus">
                        <strong>{{clientOrBu.clientOrBuName}}</strong>
                        <span *ngIf="clientOrBu.clientOrBuLocation !== null"> at <span>{{clientOrBu.clientOrBuLocation}}</span></span>
                        <table class="table table-bordered" style="margin-top: 10px">
                            <thead>
                                <tr>
                                    <th>Requisition Number</th>
                                    <th>Role Name</th>
                                    <th>Candidates in {{stepName}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let req of clientOrBu.requisitionDetailResponseDTO">
                                    <td>{{req.requisitionActualNumber}}</td>
                                    <td>{{req.name}}</td>
                                    <td>{{req.numberOfCandidates}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </li>
                </ol>
            </div>
        </div>

        <div class="col-xs-12 text-right" style="margin-top:10px">
            <div class="clearfix">
                <button type="button" class="btn btn-primary" (click)="closeModal()">OK</button>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="!isDetailsFetched">
        <div class="col-xs-12">
            <app-skeleton-loader variant="lines" [rows]="4"></app-skeleton-loader>
        </div>
    </div>
</div>
